// extracted by mini-css-extract-plugin
export default {"App-header":"App_App-header__AR3S2","finalClosure":"App_finalClosure__99IBf","finalClosureText":"App_finalClosureText__VHovZ","finalClosurePadding":"App_finalClosurePadding__9M+3K"};